<template>
<main id="main" role="main" class="main">
    <div class="section">
        <div class="container">

        </div>
    </div>
</main>
</template>

<script>
export default {
    name        :   'Homepage',
    props       :   ['site_data']
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ErrorPage.vue